import type { MessageDescriptor } from 'react-intl';
import type { OutreachReplyLabel } from 'fym-shared/src/music24/outreach/types';
import { REPLY_LABEL_TEXT } from '../inbox/replyLabels';

/**
 * The reply label of an activity event or a toast. The contract sends `payment` for the inbox
 * label `asksForPayment`; an unknown label reads "Other".
 */
export function replyLabelOf(label: string | null): OutreachReplyLabel {
  if (label === 'payment') {
    return 'asksForPayment';
  }
  return label !== null && label in REPLY_LABEL_TEXT ? (label as OutreachReplyLabel) : 'other';
}

export function replyLabelText(label: string | null): MessageDescriptor {
  return REPLY_LABEL_TEXT[replyLabelOf(label)];
}
